import * as React from 'react';
import { cn } from '@/lib/utils';
import { Checkbox as UICheckbox } from '@/components/ui/Checkbox';
import { Label } from '@/components/ui/Label';

export enum CheckboxVariant {
    DEFAULT = 'default',
    WHITE = 'white',
}

export type CheckboxChecked = boolean | 'indeterminate';

interface CheckboxProps {
    checked?: CheckboxChecked;
    onChange?: (checked: CheckboxChecked) => void;
    label?: React.ReactNode;
    disabled?: boolean;
    required?: boolean;
    variant?: CheckboxVariant;
    id?: string;
    className?: string;
    labelClassName?: string;
    wrapperClassName?: string;
}

export function Checkbox({
    checked = false,
    onChange,
    label,
    disabled = false,
    required,
    variant = CheckboxVariant.DEFAULT,
    id,
    className,
    labelClassName,
    wrapperClassName,
}: CheckboxProps) {
    const checkboxId = id ?? React.useId();
    const isChecked = checked === true || checked === 'indeterminate';

    const checkboxElement = (
        <UICheckbox
            id={checkboxId}
            checked={checked}
            onCheckedChange={(value) => onChange?.(value)}
            disabled={disabled}
            variant={variant === CheckboxVariant.WHITE ? 'white' : 'default'}
            className={className}
        />
    );

    if (label) {
        return (
            <div
                className={cn(
                    'flex items-center gap-2 group',
                    wrapperClassName,
                )}
            >
                {checkboxElement}
                <Label
                    htmlFor={checkboxId}
                    required={Boolean(required)}
                    className={cn(
                        disabled
                            ? 'cursor-not-allowed text-grey-300'
                            : isChecked
                              ? 'cursor-pointer text-white-100'
                              : 'cursor-pointer text-grey-200',
                        labelClassName,
                    )}
                >
                    {label}
                </Label>
            </div>
        );
    }

    return checkboxElement;
}
